"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyboardEventHandler = void 0;
const react_1 = require("react");
/* eslint-disable no-unused-vars */
var Keys;
(function (Keys) {
    Keys["up"] = "ArrowUp";
    Keys["down"] = "ArrowDown";
    Keys["left"] = "ArrowLeft";
    Keys["right"] = "ArrowRight";
    Keys["home"] = "Home";
    Keys["end"] = "End";
    Keys["enter"] = "Enter";
    Keys["esc"] = "Escape";
    Keys["space"] = "Space";
})(Keys || (Keys = {}));
/**
 * A hook that binds keyboard event with keyboard handlers
 * @param onUp callback that will be called when event relates to up arrow key
 * @param onDown callback that will be called when event relates to down arrow key
 * @param onLeft callback that will be called when event relates to left arrow key
 * @param onRight callback that will be called when event relates to right arrow key
 * @param onHome callback that will be called when event relates to home key
 * @param onEnd callback that will be called when event relates to end key
 * @param onEscape callback that will be called when event relates to escape key
 * @param onEnter callback that will be called when event relates to enter key
 * @returns event handler that has to be added to focusable element that will listen for keyboard events
 */
const useKeyboardEventHandler = ({ onUp, onDown, onLeft, onRight, onHome, onEnd, onEscape, onEnter, onSpace, }) => (0, react_1.useCallback)((event) => {
    const code = event.nativeEvent.code;
    const callback = {
        [Keys.down]: onDown,
        [Keys.up]: onUp,
        [Keys.left]: onLeft,
        [Keys.right]: onRight,
        [Keys.end]: onEnd,
        [Keys.home]: onHome,
        [Keys.enter]: onEnter,
        [Keys.esc]: onEscape,
        [Keys.space]: onSpace,
    }[code];
    if (callback) {
        callback();
        event.stopPropagation();
        event.preventDefault();
    }
}, [onUp, onDown, onRight, onLeft, onHome, onEnd, onEscape, onEnter, onSpace]);
exports.useKeyboardEventHandler = useKeyboardEventHandler;
//# sourceMappingURL=useKeyboardEventHandler.js.map